import http from './http'

export default {
  groupBuying: {
    get (id) {
      return http.get('/marketing/groupbuying/get', {id: id})
    },
    getList (search, pageConfig) {
      return http.get('/marketing/groupbuying/getlist', {
        keyword: search.keyword,
        shopId: search.shop,
        startDate: search.startDate,
        endDate: search.endDate,
        pageIndex: pageConfig.pageIndex,
        pageSize: pageConfig.pageSize
      })
    },
    getOrderListByGroupbying (id, pageConfig) {
      return http.get('/marketing/groupbuying/getorderlistbygroupbying', {
        id: id,
        pageIndex: pageConfig.pageIndex,
        pageSize: pageConfig.pageSize
      })
    },
    getOrderList (search, pageConfig) {
      return http.get('/marketing/groupbuying/getorderlist', {
        name: search.name,
        keyword: search.keyword,
        shopId: search.shop,
        startDate: search.startDate,
        endDate: search.endDate,
        deliverType: search.deliverType,
        status: search.status,
        pageIndex: pageConfig.pageIndex,
        pageSize: pageConfig.pageSize
      })
    },
    getOrderSummary (search, pageConfig) {
      return http.get('/marketing/groupbuying/getordersummary', {
        shopId: search.shop,
        startDate: search.startDate,
        endDate: search.endDate,
        pageIndex: pageConfig.pageIndex,
        pageSize: pageConfig.pageSize
      })
    },
    getDeliverTypeList () {
      return http.get('/marketing/groupbuying/getdelivertypelist')
    },
    getOrderStatusList () {
      return http.get('/marketing/groupbuying/getorderstatuslist')
    },
    create (model) {
      return http.post('/marketing/groupbuying/create', model)
    },
    update (model) {
      return http.post('/marketing/groupbuying/update', model)
    },
    delete (ids) {
      return http.post('/marketing/groupbuying/delete', ids)
    }
  }
}



// WEBPACK FOOTER //
// ./src/api/marketing.js